import React, { useEffect } from 'react';
import { resolvePath, useNavigate, useParams } from 'react-router-dom';

import { pages } from 'pages';
import { Header } from 'shared/components/Header/Header';
import { useGetFAQs } from 'api/faqs';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import { BodyText, FAQWrapper, Title, VPPFAQStyled } from './VPPFAQ.styles';

export function VPPFAQ() {
  const { faqId } = useParams();
  const navigate = useNavigate();
  const { data: faqData, isLoading } = useGetFAQs();

  const faqToShow = faqData?.find((faq) => faq.id === faqId);

  useEffect(() => {
    if (!isLoading && !faqToShow) {
      navigate(`/${pages.DASHBOARD}/${pages.VPP}/${pages.VPP_FAQ}`);
    }
  }, [faqToShow, isLoading, navigate]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!faqToShow) {
    return null;
  }
  return (
    <VPPFAQStyled>
      <Header
        pageName="VPP_FAQS"
        routeBreadCrumbs={[
          { label: 'Virtual Power Plant', link: resolvePath(pages.VPP, `/${pages.DASHBOARD}`) },
          {
            label: 'VPP FAQs',
            link: resolvePath(pages.VPP_FAQS, `/${pages.DASHBOARD}/${pages.VPP}`),
          },
          { label: faqToShow.question },
        ]}
      />

      <FAQWrapper>
        <Title as="h1">{faqToShow.question}</Title>
        <BodyText as="p">{faqToShow.answer}</BodyText>
      </FAQWrapper>
    </VPPFAQStyled>
  );
}

export default VPPFAQ;
